/**
 * @module
 *
 * @import {XUserPopup} from '../../core/service/backend/x-userpopups.js';
 */

import {user} from '../../user/user.js';
import {now} from '@acng/frontend-bounty/timing/now.js';
import {livecamSession} from '../../livecam/context/session.js';
import {inject} from '../../core/service/ng.js';
import {loginTime} from '../../user/auth/login.js';
import {NotificationManager} from '../../user/notification-manager.js';
import {FSK_DISCLAIMER_DONE, localStore} from '../../api/browser-storage.js';
import {make} from '../../core/service/env.js';
import {AgeVerification} from '../../user/age-verification.js';

let passwordResetToken = false;
let showDoiHint = false;
let showChangeEmail = false;
let rename = false;
let hadRename = false;
const forceFskDisclaimer = false; // true: shows the fsk disclaimer overlay regardless of the user conditions
let fskDisclaimerDone = localStore[FSK_DISCLAIMER_DONE];

/**
 * @param {XUserPopup[]} popupList
 */
const setPopups = (popupList) => {
  for (const {template} of popupList) {
    switch (template) {
      case 'doiHint':
        showDoiHint = true;
        break;
      case 'renameOverlay':
        rename = !hadRename;
        break;
      case 'changeEmail':
        showChangeEmail = true;
        break;
      case 'requestMailDoi':
        showDoiHint = true;
        break;
    }
  }
};

const triggerPopups = () => {
  const onsOverlay = inject('onsOverlay');

  if (user.guest || livecamSession || onsOverlay.count()) {
    return;
  }
  //onsOverlay.create('confirm-device').disableBackdrop().open();

  if (passwordResetToken) {
    onsOverlay
      .create('passwordSetOverlay', {
        email: user.email,
        token: user.password_reset_token,
      })
      .disableBackdrop()
      .disableCloseButtonInToolbar()
      .open();

    passwordResetToken = false;
  } else if (rename) {
    onsOverlay.create('renameOverlay').disableBackdrop().disableCloseButtonInToolbar().open();

    rename = false;
    hadRename = true;
  } else if ((user.ageVerificationPopupAvailable() && !fskDisclaimerDone) || forceFskDisclaimer) {
    fskDisclaimerDone = true;
    make(AgeVerification).showFskDisclaimer();
  } else if (showDoiHint) {
    if (!user.doi_at) {
      onsOverlay.create('doiHint').disableBackdrop().open();
    }

    showDoiHint = false;
  } else if (showChangeEmail) {
    onsOverlay.create('changeEmailOverlay').disableBackdrop().open();
    showChangeEmail = false;
  } else {
    triggerConfirmNotification();
  }
};

let confirmNotificationDone = false;

const triggerConfirmNotification = async () => {
  const delaySeconds = 10;

  if (confirmNotificationDone || now() - loginTime < delaySeconds * 1e3) {
    return;
  }

  confirmNotificationDone = true;
  (await make(NotificationManager).confirm())?.open(['core', 'confirm-notification']);
};

export {setPopups, triggerPopups};
